import { render } from "./Jishiqi.vue?vue&type=template&id=482b8ec4&scoped=true&ts=true"
import script from "./Jishiqi.vue?vue&type=script&lang=ts"
export * from "./Jishiqi.vue?vue&type=script&lang=ts"

import "./Jishiqi.vue?vue&type=style&index=0&id=482b8ec4&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482b8ec4"]])

export default __exports__